module.exports = __webpack_public_path__ + "img/symbol_10.c39245a2.png";